export const clampRateInput = (raw)=>{
    const match = raw.match(/^(\d*)(?:\.(\d{0,2}))?/);
    if (match == null) return '';
    const [, whole = '', decimals] = match;
    if (decimals == null) return raw.includes('.') ? "".concat(whole, ".") : whole;
    return "".concat(whole, ".").concat(decimals);
};
